import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Centered } from '../../../components/common';
import { useTheme } from '../../../components/common/providers/DialectThemeProvider';
const NoWalletError = ({ message }) => {
    const { icons } = useTheme();
    return (_jsxs(Centered, { children: [_jsx(icons.notConnected, { className: "dt-mb-6 dt-opacity-60" }), _jsx("span", { className: "dt-text-center", children: message ? message : 'Wallet not connected' })] }));
};
export default NoWalletError;
//# sourceMappingURL=NoWalletError.js.map